module.exports = __webpack_public_path__ + "static/img/19.e0b33f5d.png";